import { ContentContainer, useDebouncedSearch } from '@gorila-shared-ui/components';
import { useState } from 'react';
import { ClientsFiltersBar } from '../../clients/ClientsFiltersBar';
import { ClientsList } from '../../clients/ClientsList';

export function ClientsPage() {
  const { search, setSearch, trigger: debouncedSearch } = useDebouncedSearch('');
  const [reloadPage, setReloadPage] = useState(false);

  return (
    <ContentContainer>
      <ClientsFiltersBar
        search={search}
        onChangeSearch={setSearch}
        onReloadPage={() => setReloadPage(!reloadPage)}
      />
      <ClientsList
        search={debouncedSearch}
        reloadPage={reloadPage}
      />
    </ContentContainer>
  );
}
